module.exports = __webpack_public_path__ + "static/media/kitsune.6c4f245e.webp";